import React from "react";
import { getOrderStatusBadgeClass } from "../Helper/CommonMethods";
import { Badge } from "react-bootstrap";
import DataTable from "react-data-table-component-with-filter";
import {
  customDataTableStyles,
  DATE_FORMAT_MOMENT,
  defaultPageLimit,
  defaultRowsPerPageOptions,
} from "../Helper/Constants";
import GetSvgIcon from "../../images/svglist";
import { Tooltip } from "react-tooltip";
import moment from "moment";

const InvoiceDetailsLists = ({ invDetails, invoiceDownload }) => {
  const columns = [
    {
      name: "Invoice Date",
      selector: (row) => moment(row.invoiceDate).format(DATE_FORMAT_MOMENT),
      sortable: true,
      filterable: true,
    },
    {
      name: "Invoice No",
      selector: (row) => row?.invoiceNo,
      sortable: true,
      filterable: true,
    },
    {
      name: "Reference No",
      selector: (row) => row?.merchantRef,
      sortable: true,
      filterable: true,
    },
    {
      name: "Customer Name",
      selector: (row) => row?.custDtls,
      sortable: true,
      filterable: true,
    },

    {
      name: "Invoice Amount",
      selector: (row) => row?.invAmt,
      sortable: true,
      filterable: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      sortable: true,
      filterable: true,
      cell: (row) => (
        <span className="p-1">
          <Badge
            className={`text-wrap ${getOrderStatusBadgeClass({
              status: row?.statusId,
            })}`}
          >
            {row?.status}
          </Badge>
        </span>
      ),
    },
    {
      name: "",
      cell: (row) => (
        <>
          <div
            data-tooltip-id={"invDTLs-" + row.invoiceNo}
            className="me-3"
            onClick={() => {
              // openInvDtls(row, "BL");
              invoiceDownload(row);
            }}
          >
            {GetSvgIcon("IconDownload")}
          </div>
          <Tooltip
            id={"invDTLs-" + row.invoiceNo}
            content="Download Invoice"
            place="left"
          />
        </>
      ),
      allowOverflow: true,
      button: true,
      width: "30px",
    },
  ];
  return (
    <>
      <div className="col-md-12 customized-data-table position-relative customize-tbl-design">
        <DataTable
          columns={columns}
          data={invDetails}
          pagination
          striped
          highlightOnHover
          paginationRowsPerPageOptions={defaultRowsPerPageOptions}
          paginationPerPage={defaultPageLimit}
          customStyles={customDataTableStyles}
        />
      </div>
    </>
  );
};

export default InvoiceDetailsLists;
